import { useTranslation } from 'react-i18next';
import { useGetInvestmentPortfolioQuery } from '@app/api/investmentsApi';
import { PageLoader } from '@app/components/PageLoader';
import formatAmount from '@modules/calculator/utils/formatAmount';
import investorBanner from '@assets/investor_banner.png';
import PortfolioSection from './PortfolioSection';
const InvestorPortfolio = () => {
    const { t } = useTranslation();
    const { data: portfolio, isLoading } = useGetInvestmentPortfolioQuery();
    const formatAmountWithCurrency = (amount) => `${formatAmount(amount, true, false)} EUR`;
    if (isLoading) {
        return <PageLoader />;
    }
    if (!portfolio) {
        return null;
    }
    const activeInvestmentData = [
        {
            label: t('financing.investing_page.outstanding_principal'),
            value: formatAmountWithCurrency(portfolio.activeInvestmentSum),
        },
        {
            label: t('financing.investing_page.total_invested_amount'),
            value: formatAmountWithCurrency(portfolio.totalInvestedAmount),
        },
        { label: t('financing.investing_page.investments_count'), value: portfolio.activeInvestmentCount },
        {
            label: t('financing.investing_page.reserved_amount'),
            value: formatAmountWithCurrency(portfolio.reservedAmount),
            tooltipText: t('financing.investing_page.reserved_amount_tooltip'),
        },
    ];
    const investmentsProfitData = [
        {
            label: t('financing.investing_page.total_profit'),
            value: formatAmountWithCurrency(portfolio.totalProfit),
            tooltipText: t('financing.investing_page.total_profit_tooltip'),
        },
        { label: t('financing.investing_page.interest'), value: formatAmountWithCurrency(portfolio.interest) },
        { label: t('financing.investing_page.late_fees'), value: formatAmountWithCurrency(portfolio.lateFees) },
    ];
    const additionalInfoData = [
        {
            label: t('financing.investing_page.returned_invested_amount'),
            value: formatAmountWithCurrency(portfolio.returnedInvestedAmount),
        },
        {
            label: t('financing.investing_page.planned_interest'),
            value: formatAmountWithCurrency(portfolio.plannedInterest),
            tooltipText: t('financing.investing_page.planned_interest_tooltip'),
        },
        {
            label: t('financing.investing_page.delayed_payments'),
            value: formatAmountWithCurrency(portfolio.delayedPayments),
            tooltipText: t('financing.investing_page.delayed_payments_tooltip'),
        },
    ];
    return (<div className="mb-6 rounded-lg overflow-hidden border border-neutral-primary-initial">
            <div className="bg-surface-neutral-primary-initial rounded-lg flex flex-col md:flex-row">
                <div className="w-full md:w-1/3 lg:w-1/4 px-4 md:pl-8">
                    <PortfolioSection title={t('financing.investing_page.active_investment')} items={activeInvestmentData}/>
                </div>

                <div className="hidden md:block w-px bg-surface-neutral-secondary-initial"/>

                <div className="w-full md:w-1/3 lg:w-1/4 px-4 md:pl-8">
                    <PortfolioSection title={t('financing.investing_page.investments_profit')} items={investmentsProfitData}/>
                </div>

                <div className="hidden md:block w-px bg-surface-neutral-secondary-initial"/>

                <div className="w-full md:w-1/3 lg:w-1/4 px-4 md:pl-8">
                    <PortfolioSection title={t('financing.investing_page.additional_info')} items={additionalInfoData}/>
                </div>

                <div className="hidden lg:flex flex-1">
                    <img src={investorBanner} alt="Investment illustration" className="h-full w-full object-cover"/>
                </div>
            </div>
        </div>);
};
export default InvestorPortfolio;
